module.exports = __webpack_public_path__ + "bkg.dfb81e89b85cfe1d4de1.jpg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/assets/login/bkg.jpg
// module id = ../../../../../src/assets/login/bkg.jpg
// module chunks = main